export const getDishPrice = ({
	portionPrices,
	price,
}: {
	portionPrices: Nullable<number>[];
	price: Nullable<number>;
}) => {
	const filtered = portionPrices.filter((el) => el !== null);
	const resolvedPrice = filtered.length >= 1 ? Math.min(...filtered) : price;
	return { hasManyPrices: filtered.length > 1, price: resolvedPrice };
};
